import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { StyleSheet, View, ScrollView } from 'react-native';
import Svg, { Defs, LinearGradient as SvgLinearGradient, Stop, Rect, } from 'react-native-svg';
import { theme } from '@xbto/design-system';
import { Col } from '../../atoms';
import { Callout } from '../../molecules';
import { ContentCard } from '../../organisms/content-card';
import { useBreakpoints, useBucketAssetUrl } from '../../hooks';
import { MAIN_CONTAINER_WIDTH_XL, } from '../../hooks/use-breakpoints';
import { useEnvironmentConfig } from 'common';
const useImageMeta = (imageUri) => {
    const { width: windowWidth, height: windowHeight, breakpoints, } = useBreakpoints();
    return useMemo(() => {
        const minImageWidth = {
            XS: 360,
            S: 660,
            M: 900,
            L: 900,
            XL: 900,
        };
        const desiredImageWidth = minImageWidth[breakpoints.current];
        const imageHeight = windowHeight * 0.9;
        return {
            breakpoints,
            meta: {
                width: windowWidth < minImageWidth.XS // Tackling the super edge case
                    ? windowWidth * 0.9
                    : desiredImageWidth > windowWidth
                        ? minImageWidth[breakpoints.prev]
                        : minImageWidth[breakpoints.current],
                height: imageHeight,
                uri: desiredImageWidth > windowWidth
                    ? imageUri[breakpoints.prev]
                    : imageUri[breakpoints.current],
            },
        };
    }, [breakpoints, windowHeight, windowWidth, imageUri]);
};
export default function ComponentWeb({ callout, imageUri, cards }) {
    const { breakpoints, meta } = useImageMeta(imageUri);
    const { REACT_APP_BUILD_ENV } = useEnvironmentConfig();
    const { srcUrl } = useBucketAssetUrl('dev', meta.uri, REACT_APP_BUILD_ENV);
    const calloutSection = (_jsx(View, { style: $.calloutContainer, children: _jsx(Callout, { title: callout.title, message: callout.message, ctas: callout.ctas, large: true }) }));
    const cardsSection = (_jsx(View, { style: [
            $.scrollviewContainer,
            breakpoints.LESS_THAN_M && $.scrollviewContainerSmall,
            breakpoints.XL && { marginHorizontal: 'auto' },
            {
                zIndex: 3,
            },
        ], children: _jsx(ScrollView, { horizontal: true, contentContainerStyle: $.contentCards, children: cards.map((card, index) => (_jsx(ContentCard, { icon: card.icon, label: card.label, description: card.description }, index))) }) }));
    const maskSection = (_jsxs(Svg, { width: "100%", height: 200, style: $.imageGradient, viewBox: "0 0 100 100", preserveAspectRatio: "none", children: [_jsx(Defs, { children: _jsxs(SvgLinearGradient, { id: "grad", x1: "0%", y1: "100%", x2: "0%", y2: "0%", children: [_jsx(Stop, { offset: "0%", stopColor: "white", stopOpacity: "1" }), _jsx(Stop, { offset: "15%", stopColor: "white", stopOpacity: "1" }), _jsx(Stop, { offset: "100%", stopColor: "white", stopOpacity: "0" })] }) }), _jsx(Rect, { x: "0", y: "0", width: "100%", height: "100%", fill: "url(#grad)" })] }));
    return (_jsxs(Col, { style: $.container, children: [calloutSection, _jsxs(View, { style: {
                    overflow: 'hidden',
                }, children: [_jsxs(View, { style: [
                            $.imageContainer,
                            {
                                width: 'auto',
                                overflow: 'visible',
                            },
                            !breakpoints.XS && { height: meta.height * 0.4 },
                        ], children: [_jsx(View, { style: [
                                    {
                                        borderRadius: 10,
                                        // @ts-expect-error - web only styles
                                        'box-shadow': '0px 0px 19.28px 9.64px rgba(0, 0, 0, 0.03)',
                                    },
                                    !breakpoints.XS && { height: meta.height * 0.4 },
                                ], children: _jsx("img", { src: srcUrl, alt: "product-splash", width: meta.width, loading: "lazy", style: {
                                        // @ts-expect-error - web only styles
                                        'background-size': `${meta.width}px auto`,
                                        'background-repeat': 'no-repeat',
                                        'background-position-y': 'top',
                                    } }) }), maskSection] }), cardsSection] })] }));
}
const $ = StyleSheet.create({
    container: {},
    calloutContainer: {
        marginTop: theme.spacing[6],
        maxWidth: 650,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    imageContainer: {
        marginTop: theme.spacing[6],
        alignSelf: 'center',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
    },
    imageGradient: {
        position: 'absolute',
        bottom: -1 * theme.spacing[6],
        zIndex: 2,
    },
    scrollviewContainer: {
        maxWidth: MAIN_CONTAINER_WIDTH_XL,
        marginTop: theme.spacing[6],
        overflow: 'hidden',
        backgroundColor: theme.color.background.white,
    },
    scrollviewContainerSmall: {
        marginTop: theme.spacing[4],
    },
    contentCards: {
        justifyContent: 'space-between',
        columnGap: theme.spacing[2],
        maxWidth: '100%',
    },
});
